<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("cardtype") }}</div>
      <router-link
        v-if="$can('create', 'Card Type')"
        class="btn-blue"
        to="add-card-type"
        >{{ $t("add") }}</router-link
      >
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <FilterByStatusDropdown
          :onSelect="(filterIsActive) => getCardList(filterIsActive)"
        />
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $tc("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-4 col-xl-3 align-self-center mb-4">
          <div class="dropdown-curve-container mr-2">
            <label
              :class="
                selected.bank && selected.bank.length > 0
                  ? 'shift-up'
                  : 'd-none'
              "
              >{{ $t("select") }} {{ $t("bank") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <multiselect
                :options="banks"
                :searchable="true"
                :placeholder="
                  selected.bank && selected.bank.length > 0
                    ? selected.bank
                    : $t('selectBank')
                "
                label="bank_name"
                track-by="bank_id"
                @select="onSelectHandler('bank', $event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
              <Tooltip :title="$t('enterbankname')" />
            </div>
            <p class="error_message"></p>
          </div>
        </div>
      </div>

      <table class="list-view-table">
        <thead>
          <tr>
            <th class="text-left">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
            <th>
              <img
                v-if="this.columnName != 'card_type'"
                @click="onSortValue('card_type', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('card_type', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('card_type', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("cardtype") }}
            </th>
            <th class="pl-2">{{ $t("bank") }}</th>
          </tr>
        </thead>
        <tbody v-if="cardname && cardname.length > 0">
          <tr v-for="(card, cardIndex) in cardname" :key="cardIndex">
            <!-- <td>
              <div class="d-flex align-items-center justify-content-end">
                <StatusDot
                  :status="
                    card.card_is_active === 'Y'
                      ? 'active'
                      : card.card_is_active === 'N' && 'inactive'
                  "
                />
                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item v-if="$can('update', 'Card Type')" v-on:click="onEditCard(card)">
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item v-on:click="onViewCard(card)">
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="card.card_is_active === 'Y' ? 'active' : 'inactive'"
                />
                <i
                  v-if="$can('update', 'Card Type')"
                  class="edit-pen icon blue-icon cursor-pointer ml-4"
                  @click="onEditCard(card)"
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                ></i>
                <i
                  class="icon-eye blue-icon cursor-pointer ml-2"
                  @click="onViewCard(card)"
                  v-b-tooltip="'View'"
                  tabindex="0"
                ></i>
              </div>
            </td>

            <td>{{ card.card_type }}</td>
            <td>{{ card.bank_name }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td style="text-align: center" colspan="3">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>

      <b-pagination
        v-if="cardname.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      card_id: "",
      card_type: "",
      bank_id: "",
      bank_name: "",
      cardname: [],

      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ],
      banks: [],
      selected: {
        bank: "",
      },

      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",
    };
  },
  beforeMount() {
    this.getBankList();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    onSortValue(columnName, orderBy) {
      if (this.selected.bank.length == 0) {
        return this.$toasted.show("Please select Bank");
      }
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getCardList();
    },
    getBankList: function () {
      let payload = {
        tableName: "ms_banks",
        bank_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.banks = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectHandler: function (type, value) {
      if (type == "bank") {
        this.bank_id = value.bank_id;
        this.selected.bank = value.bank_name;
        this.getCardList();
      }
    },
    getCardList: function (filterIsActive = "Y") {
      this.cardname = [];
      MarketingService.getAllCardType(
        this.perPage,
        this.currentPage,
        this.bank_id,
        this.columnName,
        this.orderBy,
        filterIsActive
      ).then((response) => {
        const { data } = response;

        if (data && data.Records.length > 0) {
          this.cardname = data.Records;
          this.rows = data.totalCount;
        }
      });
    },
    onViewCard: function (card) {
      this.$router.push({
        path: "/marketing/view-card-type",
        query: { card_id: card.card_id },
      });
    },
    onEditCard: function (card) {
      this.$router.push({
        path: "/marketing/edit-card-type",
        query: { card_id: card.card_id },
      });
    },

    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getCardList();
      } else {
        this.currentPage = event;
        this.getCardList();
      }
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CardTypeComponents/cardType.vue